import axios from '../axios'
// 流水明细列表
export const getRwJournalCapitalPage = (data) => {
  return axios({
    url: '/api/sys/rw/getRwJournalCapitalPage',
    method: 'post',
    data
  })
}
export const exportPurArrivalGrade = (data) => {
  return axios({
    url: '/api/sys/pur/arrival/exportPurArrivalGrade',
    method: 'post',
    data
  })
}
export const getPurArrivalGradeList = (data) => {
  return axios({
    url: '/api/sys/pur/arrival/getPurArrivalGradeList',
    method: 'post',
    data
  })
}
// 获取采购结算单明细
export const getArrivalEntryListBySettleNo = (data) => {
  return axios({
    url: '/api/sys/pur/arrival/getArrivalEntryListBySettleNo',
    method: 'post',
    data
  })
}

// 首页收入统计
export const getTotalAmount = (data) => {
  return axios({
    url: '/api/sys/t/report/getTotalAmount',
    method: 'post',
    data
  })
}

// 首页客户统计
export const getCustomerByTime = (data) => {
  return axios({
    url: '/api/sys/t/report/getCustomerByTime',
    method: 'post',
    data
  })
}

// 按时间获取网店收入
export const getOnlineStoreIncome = (data) => {
  return axios({
    url: '/api/sys/t/report/getOnlineStoreIncome',
    method: 'post',
    data
  })
}

// 按时间获取门店收入
export const getStoreIncome = (data) => {
  return axios({
    url: '/api/sys/t/report/getStoreIncome',
    method: 'post',
    data
  })
}

// 首页累计未核销金额
export const unsettledAmount = (data) => {
  return axios({
    url: '/api/sys/t/report/unsettledAmount',
    method: 'post',
    data
  })
}

// 门店核销（入参与 GetTotalAmountForm 一致）
export const storeWriteOff = (data) => {
  return axios({
    url: '/api/sys/t/report/storeWriteOff',
    method: 'post',
    data
  })
}

// 商品销售统计（按商品聚合，仅已支付订单）
export const productSaleStatistic = (data) => {
  return axios({
    url: '/api/sys/t/report/productSaleStatistic',
    method: 'post',
    data
  })
}

// 日报：按日收入（入参与 getTotalAmount 相同）
export const dailyIncomeReport = (data) => {
  return axios({
    url: '/api/sys/t/report/dailyIncomeReport',
    method: 'post',
    data
  })
}

// 月报：按月收入（入参与 getTotalAmount 相同）
export const monthlyIncomeReport = (data) => {
  return axios({
    url: '/api/sys/t/report/monthlyIncomeReport',
    method: 'post',
    data
  })
}

// 收款通道报表（按通道聚合，仅已支付订单）
export const paymentChannelReport = (data) => {
  return axios({
    url: '/api/sys/t/report/paymentChannelReport',
    method: 'post',
    data
  })
}

// 环比报表（CompareReportQueryForm；startDate/endDate 为 yyyy-MM-dd HH:mm:ss）
export const periodOverPeriodReport = (data) => {
  return axios({
    url: '/api/sys/t/report/periodOverPeriodReport',
    method: 'post',
    data
  })
}

// 同比报表（固定三列：本期|去年同期|同比；startDate/endDate 为 yyyy-MM-dd HH:mm:ss）
export const samePeriodPreviousCycleReport = (data) => {
  return axios({
    url: '/api/sys/t/report/samePeriodPreviousCycleReport',
    method: 'post',
    data
  })
}

// 商品核销报表（按商品聚合，仅已核销明细）
export const productVerifyReport = (data) => {
  return axios({
    url: '/api/sys/t/report/productVerifyReport',
    method: 'post',
    data
  })
}

// 热门项目排行榜
export const projectRanking = (data) => {
  return axios({
    url: '/api/sys/t/report/projectRanking',
    method: 'post',
    data
  })
}

// 热门项目排行榜(金额)
export const projectRankingAmount = (data) => {
  return axios({
    url: '/api/sys/t/report/projectRankingAmount',
    method: 'post',
    data
  })
}

// 客户来源
export const customerSource = (data) => {
  return axios({
    url: '/api/sys/t/report/customerSource',
    method: 'post',
    data
  })
}

// 票种占比
export const ticketTypeShare = (data) => {
  return axios({
    url: '/api/sys/t/report/ticketTypeShare',
    method: 'post',
    data
  })
}

// 时段客流
export const periodFlow = (data) => {
  return axios({
    url: '/api/sys/t/report/periodFlow',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/moudules/report.js